// extracted by mini-css-extract-plugin
module.exports = {"sauron-error-card":"errorCard_sauron-error-card__2ICkA"};